/* eslint-disable linebreak-style */
import React, {useState} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardHeader,
  CardActions,
  Divider,
  Button,
  colors
} from '@material-ui/core';
import {strapi, STRAPI_PASSWORD_RESET_URL} from '../../../../strapi/strapi.config';
import { withSnackbar } from 'notistack';
import { selectCurrentUser } from '../../../../redux/user/user.selectors'
import { t } from '../../../../i18n';

const useStyles = makeStyles(() => ({
  root: {},
  alignButton:{
    desplay:'flex',
    justifyContent: 'flex-end' 
  },
  buton:{
    width:'100%', 
    background:colors.blueGrey[500],
    color:'white' 
  },
  header:{
    background:colors.blueGrey[700],
  }
}));

const Notifications = props => {
  const { className, enqueueSnackbar, currentUser } = props;
  const [enabled, setEnabled]=useState(true)
  const classes = useStyles();
  //----------------------------------------------------------------------------------------
  const handleSubmit= async (e)=>{
    e.preventDefault()
    setEnabled(false)
    await strapi.forgotPassword(currentUser.email, STRAPI_PASSWORD_RESET_URL)
      .catch(e=>(
        enqueueSnackbar(t('settings.resetPasswordSendError', { error: e }),{ 
          variant: 'error',
          persist:true,  
        })
      ))
      .then(()=>{
        enqueueSnackbar(t('settings.resetPasswordSendSuccess'),{ 
          variant: 'success',
          autoHideDuration:1500
        })
      })
  }
  //----------------------------------------------------------------------------------------

  return (
    <Card
      className={clsx(classes.root, className)}
    >
      <form
        onSubmit={handleSubmit}
      >
        <CardHeader 
          className={classes.header}
          subheader={t('settings.resetPasswordSubheader')}
          title={t('settings.resetPasswordTitle')}
        />
        <Divider />
        
        <CardActions className={classes.alignButton}>
          <Button 
            className={classes.buton}
            color="primary"
            disabled={!enabled}
            type="submit"
            variant="outlined"         
          >
            {t('settings.resetPasswordButton')}
          </Button>
        </CardActions>
      </form>
    </Card>
  );
};

Notifications.propTypes = {
  className: PropTypes.string,
  currentUser:PropTypes.object,
  enqueueSnackbar:PropTypes.func

};

const mapStateToProps=state=>({
  currentUser:selectCurrentUser(state)
})

export default connect(mapStateToProps)(withSnackbar(Notifications));
